






























































































import {Component, Vue} from 'vue-property-decorator'
import ProductInfoView from "@/view/device-manage/product/info.vue";
import FunView from "@/view/device-manage/product/fun.vue";
import productModule from "@/store/module/ProductModule";
import InstrTmplView from "@/view/device-manage/product/instr-tmpl.vue";
import FirmwareView from "@/view/device-manage/firmware/index.vue";
import ProductMacView from "@/view/device-manage/product/mac.vue";
import ProductActivationView from "@/view/device-manage/product/activation.vue";
import ProductConfigView from "@/view/device-manage/product/config.vue";
import SpanNullable from "@/component/Span/span-nullable.vue";
import PactStatisticsView from "@/view/device-manage/product/act-statistics.vue";
import {handleClipboard} from "@/util/clipboard";

@Component({
  components: {
    SpanNullable,
    ProductInfoView,
    FunView,
    InstrTmplView,
    FirmwareView,
    ProductMacView,
    ProductActivationView,
    ProductConfigView,
    PactStatisticsView,
  },
})
export default class ProductDetailView extends Vue {

  private get product() {
    return productModule.active
  }

  private copy = handleClipboard
}
